import React, { Component } from 'react'
import styled from 'styled-components'
import queryString from 'query-string'
import PropTypes from 'prop-types'
import { push } from 'react-router-redux'
import R, { clone } from 'ramda'
import moment from 'moment'
import { Form as UnstyledForm} from 'formsy-react-2'
import { Table, TableCell, TextIcon, TableHeader, TableLoading, TextInput, Select,
  Title, Colors, Button, Pagination, ContextMenu } from 'advenio-components'
import { connect } from 'react-redux'
import ProfileHeader from '../../Components/ProfileHeader'
import ParentProfileForm from '../../Components/ParentComponents/ParentProfileForm'
import InvoiceDataForm from '../../Components/ParentComponents/InvoiceDataForm'
import ReservationBmxActions from '../../Data/Redux/ReservationBmxRedux'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'
import CoursesActions from '../../Data/Redux/CoursesRedux'
import { parseFullName } from '../../utils/Utils'
import LoadingSpinner from '../../Components/LoadingSpinner'
import { UsoCFDIKeys } from '../StudentProfile/ParentProfile'

const FormParent = styled.div`
  box-sizing: border-box;
  background: #fff;
  border: solid transparent 1px;
  border-radius: 5px;
`
const Container = styled.div`
  padding: 54px;
`
const Form = styled(UnstyledForm)`
  display: flex;
  flex-direction: column;
  width: 100%;
`
const ProfileSection = styled.div`
  display: flex;
  width:100%;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
`
const ErrorZone = styled.div`
  flex:1;
  justify-content: flex-start;
  display: flex;
  background: ${Colors.red100};
  flex-direction: column;
  color:${Colors.redText};
  padding: 16px;
  h3 {
    margin:0;
    margin-bottom: 16px;
  }
`
const ErrorRow = styled.div`
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  div {
    display: flex;
    flex-direction: column;
  }
`
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
`
const newParent = {
  relation_id: null,
  nickname: '',
  contact_numbers: {
    phone_number: '',
    cellphone_number: '',
  },
  email:'',
  first_name: '',
  last_name_maternal: '',
  last_name_paternal: '',
  company_id: null,
  pays_automatically: false,
  requires_invoices: false,
}

class CreateProfile extends Component {
  state = {
    typeModal: 'authorize',
    modalServiceOpen: false,
    pageSelected:1,
    queryParams: {},
    reservationId:0,
    modalResverationBmxOpen:false,
    student:null,
    parents:[],
    parent: newParent,
    errorFlag: false,
    requires_invoice:false,
    optionsRimgentFiscal:[{id:0,label:'Seleciona regimen fiscal',value:0}]
  }

  componentWillMount = () => {
  }

  componentWillReceiveProps (nextProps) {
  }

  onSubmit = (data) => {
    const  { user, sendPerson} = this.props
    let errorFlag = false
    if(data.requires_invoices){

      if (data.tax_info !== undefined){
        const hasUndefine = Object.keys(data.tax_info).filter(item => (typeof data.tax_info[item] === 'undefined' || data.tax_info[item] === ''))
        if(hasUndefine.length > 0){
          errorFlag = true
          this.setState({ errorFlag })
          return false
        }
      }
    }
    // const hasValues = Object.keys(data.tax_info).filter(item => (typeof data.tax_info[item] !== 'undefined'|| data.tax_info[item] !== ''))

  if(! data.requires_invoices ) {
    delete data.tax_info
  }

    this.setState({errorFlag})
    data.center_id = user.center_id
    sendPerson(data)
  }

  onFilter = (query) => {
    console.log(query)
  }
  onChange = (data) => {
    const requires_invoice = data.requires_invoices
    this.setState({requires_invoice})
  }

  renderRegimenOtions = () => (
    this.props.regimenFiscal.map(relation => ({
      id: relation.sat_key,
      label: relation.sat_key+' - '+relation.name,
      value: relation.sat_key,
    }))
  )

  renderUsoCFDIOtions = () => (
    this.props.uso_cfdi.filter(key => key.sat_key !== 'CP01').map(relation => ({
      id: relation.id,
      label: relation.sat_key+' - '+relation.name,
      value: relation.id,
    }))
  )

  changeUsoCFDI = ({target:{value}}) => {
    const { uso_cfdi, regimenFiscal } = this.props
    const [usoCFDI] = uso_cfdi.filter(uso => uso.id === Number(value))
    const [UsoCFDIKey] = UsoCFDIKeys.filter(key => key.id === usoCFDI.sat_key)
    let optionsRimgentFiscal = clone(this.state.optionsRimgentFiscal)
    optionsRimgentFiscal.concat(clone(regimenFiscal.filter(regimen => UsoCFDIKey.regimens.includes(Number(regimen.sat_key))).map(regimenFiscal => ({
      id: regimenFiscal.sat_key,
      label: regimenFiscal.sat_key+' - '+regimenFiscal.name,
      value: regimenFiscal.sat_key,
    }))))
    this.setState({optionsRimgentFiscal})
  }

  render() {
    const { centerProducts, studyPrograms, classrooms, meta,loading, loadingCompanies } = this.props
    const { pageSelected, center, queryParams, parents, parent, errorFlag, requires_invoice,optionsRimgentFiscal } = this.state
    if (loadingCompanies){
      return <LoadingSpinner />
    }
    return (
      <Container>
        <HeaderContainer>
          <Title>Crear Perfíl</Title>
        </HeaderContainer>
        {/* <FilterContainer>
            <Form onSubmit={this.onFilter}>
              <Filters>
                <FiltersContainer input>
                  <InputContainer>
                    <TextInput
                      name="name"
                      label="Nombre del tutor"
                      value={queryParams.name || ''}
                      help={'Ingresa el nombre del tutor existente en Advenio.'}
                    />
                  </InputContainer>
                  <Send>
                   <Button loading={loading} primary small type="submit">Buscar</Button>
                  </Send>
                </FiltersContainer>
                <FiltersContainer>
                  <InputContainer select>
                    <Select
                      name="tutor"
                      label="Selecionar Tutor"
                      options={parents}
                      emptyElement
                      onChangeCallback={this.changeSelect}
                    />
                  </InputContainer>
                </FiltersContainer>
              </Filters>
            </Form>
          </FilterContainer> */}
          <FormParent>
            <Form onSubmit={this.onSubmit} onChange={this.onChange}>
            <ProfileHeader
              header="Perfíl"
              submit
              loading={loading}
            />
            <ParentProfileForm info={parent}  showRelation={false} paymentAutomatic={false}/>
            {errorFlag &&(
            <ProfileSection>
            <ErrorZone>
                <h3>Precaución</h3>
                <ErrorRow>
                  <div>
                    <span>Asegurate de que los campos de Facturacion esten llenos si se requiere factura.</span>
                    {/* <span>Este proceso puede ser revertido en la pantalla de inscripciones</span> */}
                  </div>
                </ErrorRow>
              </ErrorZone>
            </ProfileSection>
        )}
       {requires_invoice &&(
         <InvoiceDataForm info={parent.tax_info || {}} regimenOtions={ optionsRimgentFiscal} usoCFDIOptions={this.renderUsoCFDIOtions()} changeUsoCFDI={this.changeUsoCFDI}/>
       )}
            </Form>
          </FormParent>
      </Container>
    )
  }
}


CreateProfile.defaultProps = {
  loading: false,
  reservations: [],
  meta: {},
  location: {},
  studentPayments:[],
}

const mapStateToProps = state => ({
  /** Error and loading for modal options */
    loading: state.reservationBmx.get.fetching,
    reservations: state.reservationBmx.get.results.data,
    meta: state.reservationBmx.get.results,
    user: state.auth.user,
    loadingpost: state.reservationBmx.postReservation.fetching,
    loadingPayments:state.reservationBmx.studentPayments.fetching,
    studentPayments: state.reservationBmx.studentPayments.results,
    loadingCompanies: state.companies.get.fetching,
    regimenFiscal : state.regimen_fiscal.get.results,
    uso_cfdi : state.uso_cfdi.get.results,

})

const mapDispatchToProps = dispatch => ({
  sendPerson: (data) => dispatch(CoursesActions.sendPersonRequest(data)),

 goTo: path => dispatch(push(path)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateProfile)



// WEBPACK FOOTER //
// ./src/Containers/Courses/CreateProfile.jsx